import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d77def76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 올바른 종이팩 재활용으로"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("우리 지구를 지켜 나갈 쓱크루를 모집합니다. ")
], -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"d-block d-md-none\" data-v-d77def76><p data-v-d77def76>종이 멸균/일반팩 1톤이 재활용되면</p><p data-v-d77def76>30년생 소나무를 20그루 심은 효과와 같아요!</p><p data-v-d77def76>하지만, 종이팩이 재활용되기 위해서는</p><p data-v-d77def76>깨끗하게 씻고 평평하게 펴서 전용 수거함에 분리배출해야 해요.</p><p data-v-d77def76>캡틴쓱과 함께 종이팩 재활용의 중요성을 알리고</p><p data-v-d77def76>메타버스 뿐만 아니라</p><p data-v-d77def76>실제 지구의 숲도 더욱 울창하게 만들어 나아가요!</p></div><div class=\"d-none d-md-block\" data-v-d77def76><p data-v-d77def76>종이 멸균/일반팩 1톤이 재활용되면 30년생 소나무를 20그루 심은 효과와 같아요!</p><p data-v-d77def76>하지만, 종이팩이 재활용되기 위해서는 깨끗하게 씻고 평평하게 펴서 전용 수거함에 분리배출해야 해요.</p><p data-v-d77def76>캡틴쓱과 함께 종이팩 재활용의 중요성을 알리고</p><p data-v-d77def76>메타버스 뿐만 아니라 실제 지구의 숲도 더욱 울창하게 만들어 나아가요!</p></div>", 2)
const _hoisted_6 = {
  class: "link",
  target: "_blank",
  href: "https://event.ssg.com/eventDetail.ssg?nevntId=1000000006424"
}

import Image from '../images/page-1/image.png';
import Button from './button.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("img", {
      src: _unref(Image),
      class: "image"
    }, null, 8, _hoisted_3),
    _hoisted_4,
    _createElementVNode("a", _hoisted_6, [
      _createVNode(Button, { text: "캠페인 자세히 알아보기" })
    ])
  ]))
}
}

})